import { styled, css, MenuList } from '@mui/material';

import ButtonContainer from '../../../components/ButtonContainer';

export const StyledUserDropdown = styled('div')(
  ({ theme }) => css`
    display: none;

    ${theme.breakpoints.up('desktop')} {
      display: block;
    }
  `
);

export const StyledUserSwitchDropdownIconAndText = styled('div')(
  ({ theme }) => css`
    align-items: center;
    column-gap: ${theme.spacing('SMALL')};
    display: flex;
  `
);

export const StyledUserMenuList = styled(MenuList)`
  max-height: 22rem;
  overflow-y: scroll;
`;

export const StyledSignoutButtonContainer = styled(ButtonContainer)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacing('1XL')};
  `
);
